/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Prop_Left_AddressInputs */

const cs_builder_prop_left_address = /** @type {(inputs: Builder_Prop_Left_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Levá adresa`)
};

const en_builder_prop_left_address = /** @type {(inputs: Builder_Prop_Left_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left address field`)
};

/**
* | output |
* | --- |
* | "Left address field" |
*
* @param {Builder_Prop_Left_AddressInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_prop_left_address = /** @type {((inputs?: Builder_Prop_Left_AddressInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Prop_Left_AddressInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_prop_left_address(inputs)
	return cs_builder_prop_left_address(inputs)
});